import { Group, rem } from "@mantine/core";
import type { CurrentUser } from "../../utils/backend-types";
import { SiteName } from "../../utils/enums";
import { Breadcrumbs } from "../Breadcrumbs/Breadcrumbs";
import { OptiNodeHelpIcon } from "../OptiNodeHelpIcon/OptiNodeHelpIcon";
import { Quicksearch } from "../Quicksearch/Quicksearch";
import { StaffViewToggle } from "../StaffViewToggle/StaffViewToggle";
import { useShouldShowStaffView } from "../StaffViewToggle/useShouldShowStaffView";
import { Brand } from "./Brand";
import { UserMenu } from "./UserMenu";

import "./Header.scss";

interface Props {
  siteName: SiteName;
  currentUser: CurrentUser | undefined;
  height: number;
  width: number;
  toggleShowStaffView: () => void;
  navbarOpened: boolean;
  navbarToggle: () => void;
}

function Header({
  siteName,
  currentUser,
  height,
  width,
  toggleShowStaffView,
  navbarOpened,
  navbarToggle
}: Props) {
  const { shouldShowStaffView } = useShouldShowStaffView();
  return (
    <div
      className="Header"
      style={
        {
          height: rem(height),
          "--base-header-nav-width": rem(width)
        } as React.CSSProperties
      }
    >
      <Brand
        height={height}
        navbarOpened={navbarOpened}
        navbarToggle={navbarToggle}
        siteName={siteName}
      />
      <Group miw={0} wrap="nowrap">
        <Breadcrumbs />
        <Group flex="0 0 auto" wrap="nowrap">
          {shouldShowStaffView && <Quicksearch />}
          <StaffViewToggle toggleShowStaffView={toggleShowStaffView} />
          {siteName === SiteName.Optinode && <OptiNodeHelpIcon />}
          <UserMenu currentUser={currentUser} siteName={siteName} />
        </Group>
      </Group>
    </div>
  );
}

export { Header };
